import {Component, Input} from '@angular/core';

@Component({
    selector: 'load-indicator',
    template: `
        <div *ngIf="loading" class="loader">
            <div class="loader__worm">
                <div class="loader__rect loader__rect--1"></div>
                <div class="loader__rect loader__rect--2"></div>
                <div class="loader__rect loader__rect--3"></div>
                <div class="loader__rect loader__rect--4"></div>
                <div class="loader__rect loader__rect--5"></div>
            </div>
        </div>`
})
export class LoadIndicator {
    @Input() loading: boolean;
    constructor() { }
}


/** WEBPACK FOOTER **
 ** ./app/common/LoadIndicator.ts
 **/